module.exports = "https://coursera_assets.s3.amazonaws.com/images/642ff0b929c710c01b8888e2622b8e29.png";